import React from "react";

function Footer() {
  return (
    <footer id="footer">
      {/* <div className="footer-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-6">
              <div className="footer-info">
                <h3>RAK municipality GIS Centre</h3>
                <p>
                  Al Nahdah St - Dafan Al Khor
                  <br />
                  Ras al Khaimah
                  <br />
                  <br />
                  <strong>Phone:</strong> +971 7 2466666
                  <br />
                  <strong>Email:</strong> gishelpdesk@mun.rak.ae
                  <br />
                </p>
                <div className="social-links mt-3">
                  <a href="#" className="twitter">
                    <i className="bx bxl-twitter"></i>
                  </a>
                  <a href="#" className="facebook">
                    <i className="bx bxl-facebook"></i>
                  </a>
                  <a href="#" className="instagram">
                    <i className="bx bxl-instagram"></i>
                  </a>
                  <a href="#" className="google-plus">
                    <i className="bx bxl-skype"></i>
                  </a>
                  <a href="#" className="linkedin">
                    <i className="bx bxl-linkedin"></i>
                  </a>
                </div>
              </div>
            </div>

            <div className="col-lg-2 col-md-6 footer-links">
              <h4>Useful Links</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">Home</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">About us</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">Terms of service</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">Privacy policy</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-3 col-md-6 footer-links">
              <h4>Our Services</h4>
              <ul>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">GIS Development</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">GIS Data Delivery</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">GIS Data Management</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">Data Sharing</a>
                </li>
                <li>
                  <i className="bx bx-chevron-right"></i> <a href="#">Application Development</a>
                </li>
              </ul>
            </div>

            <div className="col-lg-4 col-md-6 footer-newsletter">
              <h4>Our Newsletter</h4>
              <p>Tamen quem nulla quae legam multos aute sint culpa legam noster magna</p>
              <form action="" method="post">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe" />
              </form>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container">
        <div className="copyright">
          &copy; Copyright{" "}
          <strong>
            <span>Ras Al Khaimah Municipality Department</span>
          </strong>
          . All Rights Reserved
        </div>
        <div className="credits">
          Developed by <a href="https://mun.rak.ae">GIS Centre</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
